
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0.358292 0.331048C0.651158 0.0381271 1.12603 0.0380826 1.41895 0.330948L7.99934 6.9101L14.5797 0.330948C14.8727 0.0380826 15.3475 0.0381271 15.6404 0.331048C15.9333 0.623968 15.9332 1.09884 15.6403 1.39171L9.0601 7.97066L15.6403 14.5496C15.9332 14.8425 15.9333 15.3174 15.6404 15.6103C15.3475 15.9032 14.8727 15.9032 14.5797 15.6104L7.99934 9.03122L1.41895 15.6104C1.12603 15.9032 0.651158 15.9032 0.358292 15.6103C0.0654264 15.3174 0.0654709 14.8425 0.358392 14.5496L6.93858 7.97066L0.358392 1.39171C0.0654709 1.09884 0.0654264 0.623968 0.358292 0.331048Z","fill":"#A1AAC6"}})])
          )
        }
      }
    